<form #form="ngForm" [formGroup]="wellForm" class="form-field-full">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader">
        <mat-icon>edit</mat-icon> Edit Well {{wellViewModel.id}}
      </h2>
    </div>
    <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <a mat-raised-button href="https://apps.wrd.state.or.us/apps/gw/well_log/Default.aspx" target="_blank"
        title="Find a Well Report">
        Find a Well Report <mat-icon>open_in_new</mat-icon></a>
    </div>
  </div>
  <br />
  <mat-tab-group dynamicHeight mat-align-tabs="begin" animationDuration="0ms"  color="primary">
    <mat-tab label="Well">
      <br />
      <div fxLayout="row wrap" class="matero-row" *ngIf="showProgressBar">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <strong>Looking up Lat/Long</strong>
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
          <br /><br />
        </div>
      </div>
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Address 1" formControlName="address1"
                    value="{{wellForm.value.address1}}">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Address 2" formControlName="address2"
                    value="{{wellForm.value.address2}}">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="City" formControlName="city" value="{{wellForm.value.city}}">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="State" formControlName="state" value="{{wellForm.value.state}}">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Zip" formControlName="zip" (change)="lookupCountyLatLong();"
                    value="{{wellForm.value.zip}}">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <mat-label>County</mat-label>
                  <mat-select id="county" name="county" formControlName="county" value="{{wellForm.value.county}}">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well Log" formControlName="wellLog" value="{{wellForm.value.wellLog}}"
                    matTooltipClass="tooltip"
                    matTooltip="This is a combination of county name and numbers; for example, a well log in Marion County could be MARI-12345">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well Tag" formControlName="tag" value="{{wellForm.value.tag}}"
                    matTooltipClass="tooltip"
                    matTooltip="Well label/tag number (L-#####). Wells built after 1996 should have a metal well tag on or near the wellhead">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Well Type" formControlName="wellType">
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-sm="100" fxLayout="column">
                <mat-form-field>
                  <mat-label>Date Well Established</mat-label>
                  <input id="dateWellEstablished" name="dateWellEstablished" formControlName="dateWellEstablished"
                    placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepicker" />
                  <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="center start">
                &nbsp;
                <mat-checkbox id="overrideLatLong" name="overrideLatLong" formControlName="overrideLatLong"
                  (click)="overrideLatLong();"><small>Override</small></mat-checkbox>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Latitude" formControlName="latitude">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Longitude" formControlName="longitude">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100" fxLayoutAlign="start center">
                <mat-checkbox id="tribalLand" name="tribalLand" formControlName="tribalLand"
                  (click)="updateTribalLand();">
                  <small>Tribal Land</small>
                </mat-checkbox>
              </div>
              <div fxFlex="66.67" fxFlex.lt-sm="100">
                <mat-form-field *ngIf="showTribalLandName">
                  <input matInput placeholder="Tribal Land Name" formControlName="tribalLandName"
                    value="{{wellForm.value.tribalLandName}}">
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Tax Lot" formControlName="taxLot">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Sample Point" formControlName="samplePoint">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input type="text" matInput placeholder="Depth" formControlName="depth">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Datum" formControlName="datum" value="{{wellForm.value.datum}}">
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100" fxLayout="column">
                <mat-form-field>
                  <input matInput placeholder="Coordinate Collection Method"
                    formControlName="coordinateCollectionMethod" value="{{wellForm.value.coordinateCollectionMethod}}">
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <br />
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Township" formControlName="township">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Range" formControlName="range">
                </mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Section" formControlName="section">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field>
                  <textarea rows="3" cols="100" placeholder="Comments" formControlName="comment"
                    value="{{wellForm.value.comment}}" matInput></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
        <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field><input matInput placeholder="Monitoring Location Id"
                    formControlName="monitoringLocationId"></mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field><input matInput placeholder="Monitoring Location Name"
                    formControlName="monitoringLocationName"></mat-form-field>
              </div>
              <div fxFlex="33.33" fxFlex.lt-sm="100">
                <mat-form-field>
                  <input matInput placeholder="Monitoring Location Desc" formControlName="monitoringLocationDescription"
                    value="{{wellForm.value.monitoringLocationDescription}}">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field>
                  <textarea rows="3" cols="100" placeholder="Monitoring Location Comments"
                    formControlName="monitoringLocationComments" value="{{wellForm.value.monitoringLocationComments}}"
                    matInput></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card>
            <mat-card-title>Decommissioning</mat-card-title>
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field> 
                  <mat-select id="decommissioned" name="decommissioned" formControlName="decommissioned" required>
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let item of oregonWellDataService.decommissionedOptions" value="{{item}}">{{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-sm="100">
                <mat-form-field> 
                  <input id="dateDecommissioned" name="dateDecommissioned" formControlName="dateDecommissioned"
                  placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickeDateDecommissioned" />
                  <mat-datepicker-toggle matSuffix [for]="datepickeDateDecommissioned"></mat-datepicker-toggle>
                  <mat-datepicker #datepickeDateDecommissioned>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div> 
            </div> 
          </mat-card>
        </div> 
      </div>
 
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="60" fxFlex.lt-sm="100" class="matero-col">
          <button type="submit" name="submit" (click)="onSubmit()" mat-raised-button color="primary"
            title="Update Well" [disabled]="authService.isReadOnly()">Update Well</button>
          <span>&nbsp;&nbsp;</span>
          <button mat-raised-button color="accent" (click)="lookupCountyLatLong();" title="Clear" [disabled]="authService.isReadOnly()">Lookup
            Lat/Long</button>
        </div>
        <div fxFlex="40" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end center">
          <small>Last Updated: {{wellViewModel.lastUpdated | date:'shortDate'}} by {{wellViewModel.lastUpdatedBy}}</small>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Samples">
      <list-samples [wellId]="wellViewModel.id"></list-samples>
    </mat-tab>
    <mat-tab label="Vouchers">
      <br />
      <list-vouchers [wellId]="wellViewModel.id"></list-vouchers>
    </mat-tab>
    <mat-tab label="Housing Units">
      <br />
      <housingunit-associations [wellId]="wellViewModel.id" [housingUnits]="true"></housingunit-associations>
    </mat-tab>
    <mat-tab label="Households">
      <br />
      <household-associations [wellId]="wellViewModel.id"></household-associations>
    </mat-tab> 
  </mat-tab-group>
</form>